exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pad___D6fkg {\n  padding: 20px; }\n", "", {"version":3,"sources":["/Users/fdev/code/factorial/factorial-components/src/components/Tooltip/TooltipPad/src/components/Tooltip/TooltipPad/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAa,EACd","file":"index.scss","sourcesContent":[".pad {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"pad": "pad___D6fkg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/fdev/code/factorial/factorial-components/styles"],"sourceMap":true}!./~/postcss-loader/lib?{"path":"/Users/fdev/code/factorial/factorial-components/webpack/postcss.config.js"}!./src/components/Tooltip/TooltipPad/index.scss
// module id = 114
// module chunks = 0